import React, {useState, useEffect} from "react"
import {connect} from "react-redux"

import ShapeFeaturesList from "./geo-map-elements/ShapeFeaturesList";
import {openSearchResultDetailsDispatchAction} from "../../state/product/dispatchActions";
import QuicklookPreviewImagesListContainer from "./geo-map-elements/QuicklookPreviewImagesList";
import {
  AllInterferometricStacksType,
  ProductImageStacType,
  SearchResultElementType,
  SearchResultsType
} from "../../types/product";
import {ConfigurationsType} from "../../types/configurations";
import {ShapeType} from "../../types/shape";
import {
  isProductImageSearchResultElement,
} from "../../helpers/searchResultsHelper";
import {AllQuicklookPreviewsType} from "../../state/geoMap/types";
import {getQuicklookPreviewsShownInMap} from "../../helpers/quicklookPreviewHelper";
import {QuicklookPreviewType} from "../../types/geoMap";
import {CartOrderType} from "../../types/cart";

interface PropsType {
  configurations: ConfigurationsType,
  formValues: any,
  selectedProducts: ProductImageStacType[],
  searchResultDetails: SearchResultElementType,
  lastShape: ShapeType,
  allQuicklookPreviews: AllQuicklookPreviewsType,
  searchResults: SearchResultsType,
  ordersSubmitted: CartOrderType[],
  allInterferometricStacks: AllInterferometricStacksType,
  openSearchResultDetailsActionHandler: any,
  kmlGuideShape: ShapeType,
}

const GeoMapElements = (props: PropsType) => {
  const {
    configurations,
    formValues,
    selectedProducts,
    searchResultDetails,
    lastShape,
    allQuicklookPreviews,
    searchResults,
    allInterferometricStacks,
    ordersSubmitted,
    openSearchResultDetailsActionHandler,
    kmlGuideShape
  } = props;

  const [quicklookPreviews, setQuicklookPreviews] = useState<QuicklookPreviewType[]>([]);

  useEffect(() => {
    setQuicklookPreviews(getQuicklookPreviewsShownInMap(allQuicklookPreviews));
    return () => {};
  }, [allQuicklookPreviews]);

  return (
    <>
      <ShapeFeaturesList
        configurations={configurations}
        formValues={formValues}
        selectedProducts={selectedProducts}
        searchResultDetails={searchResultDetails}
        lastShape={lastShape}
        quicklookPreviews={quicklookPreviews}
        searchResults={searchResults}
        allInterferometricStacks={allInterferometricStacks}
        onShapeClick={(element: SearchResultElementType) => openSearchResultDetailsActionHandler(element)}
        isKml={false}
      />

      <ShapeFeaturesList
        configurations={configurations}
        formValues={formValues}
        selectedProducts={selectedProducts}
        searchResultDetails={searchResultDetails}
        lastShape={kmlGuideShape}
        quicklookPreviews={quicklookPreviews}
        searchResults={searchResults}
        allInterferometricStacks={allInterferometricStacks}
        onShapeClick={(element: SearchResultElementType) => openSearchResultDetailsActionHandler(element)}
        isKml={true}
      />

      {/*@mapitaly: non ci sono ordersSubmitted per ora*/}
      <QuicklookPreviewImagesListContainer
        selectedProducts={selectedProducts}
        ordersSubmitted={[]}
        productDetails={isProductImageSearchResultElement(searchResultDetails) ? searchResultDetails as ProductImageStacType : null}
        quicklookPreviews={quicklookPreviews}
        onQuicklookPreviewImageClick={(productImage: ProductImageStacType) => openSearchResultDetailsActionHandler(productImage)}
      />
    </>
  )
};

const mapStateToProps = (state) => ({
  searchResults: state.product.searchResults,
  allInterferometricStacks: state.product.allInterferometricStacks,
  ordersSubmitted: state.cart.ordersSubmitted
});

const mapDispatchToProps = (dispatch) => ({
  openSearchResultDetailsActionHandler: (item) => dispatch(openSearchResultDetailsDispatchAction(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(GeoMapElements);
